/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IdentityEntityResult { 
    /**
     * Commercial name of the entity.
     */
    commercialName?: string;
    /**
     * Logo of the entity. Encoded in Base64 format
     */
    logo?: IdentityEntityResult.LogoEnum;
    /**
     * Public key of the entity. Encoded in Base64 format
     */
    publicKey?: IdentityEntityResult.PublicKeyEnum;
    /**
     * Entity type: ServiceProvider (true) or Issuer (false).
     */
    serviceProviderOrIssuer?: boolean;
}
export namespace IdentityEntityResult {
    export type LogoEnum = '[B@2b59501e';
    export const LogoEnum = {
        B2b59501e: '[B@2b59501e' as LogoEnum
    };
    export type PublicKeyEnum = '[B@476e8796';
    export const PublicKeyEnum = {
        B476e8796: '[B@476e8796' as PublicKeyEnum
    };
}


